
import { Observable } from 'rxjs/Rx';
import {map} from 'rxjs/operators';
import {ICountry} from '../models/country.interface';
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class CountryService {

  private countries: Observable<ICountry[]> = null;

  constructor(private http: HttpClient) {
    this.countries = this.loadData();
  }

  private loadData(): Observable<any> {
    return this.http.get('./assets/data/countries.json')
      .map((res: Response) => {
        return res || {};
      })
      .catch(this.handleError);
  }

  private handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error instanceof HttpErrorResponse) {
      if (error.status === 404) {
        errMsg = 'Error loading countries.json file. Please configure WebPack and load countries.json assets to your root folder';
      }
      const body = error.error || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  getCountries(): Observable<ICountry[]> {
    return this.countries.map(countries => countries.map(country => {
      return country;
    }));
  }
}
